export const thousandsSeparator = ( value ) => {
    return String(value).replace(/(\d{1,3})(\d{3})$/, "$1 $2,-");
}